import { render, staticRenderFns } from "./error-403.vue?vue&type=template&id=b9fa1520&scoped=true&"
import script from "./error-403.vue?vue&type=script&lang=js&"
export * from "./error-403.vue?vue&type=script&lang=js&"
import style0 from "./error-403.vue?vue&type=style&index=0&id=b9fa1520&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fa1520",
  null
  
)

export default component.exports